import { Component } from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";
import { Subscription } from "rxjs";
import "rxjs/add/operator/pairwise";
import "rxjs/add/operator/first";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  private _routeScrollPositions: { [url: string]: number } = {};
  private _subscriptions: Subscription[] = [];
  routerSubscription: Subscription;

  constructor(private router: Router, private location: Location) {}

  ngOnInit() {
    this._subscriptions.push(
      // save scroll position on route change
      this.router.events.pairwise().subscribe(([prevRouteEvent, currRouteEvent]) => {
        if (prevRouteEvent instanceof NavigationEnd && currRouteEvent instanceof NavigationStart) {
          // url path without parameters
          let urlPath = (prevRouteEvent.urlAfterRedirects || prevRouteEvent.url).split(";", 1)[0];
          this._routeScrollPositions[urlPath] = window.pageYOffset;
        }
      })
    );

    // restore scroll position on back or forward
    this.location.subscribe((event) => {
      // back or forward, wait for router navigation end
      let routerNavigationEnd = this.router.events
        .first((event) => event instanceof NavigationEnd)
        .subscribe((navigationEndEvent: NavigationEnd) => {
          // url path without parameters
          let urlPath = (navigationEndEvent.urlAfterRedirects || navigationEndEvent.url).split(
            ";",
            1
          )[0];
          console.log("scroll to ", this._routeScrollPositions[urlPath] || 0);
          setTimeout(() => {
            window.scrollTo(0, this._routeScrollPositions[urlPath] || 0);
          }, 0);
        });
    });
  }

  onDeactivate() {
    document.body.scrollTop = 0;
  }

  ngOnDestroy() {
    this._subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts